export enum CustomerReportStatus {
  SENT = 'SENT',
  DRAFT = 'DRAFT',
  CANCEL = 'CANCEL',
  IN_APPROVAL = 'IN_APPROVAL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum RecipientType {
  MAIN = 'MAIN',
  CC = 'CC',
  BCC = 'BCC',
}

export enum ReportFrequency {
  WEEKLY = 'WEEKLY',
  BIWEEKLY = 'BIWEEKLY',
}

export interface CustomerReport {
  id: string;
  projectId: number;
  title: string;
  periodStart: string;
  periodEnd: string;
  status: CustomerReportStatus;
  template: string;
  externalReportLink?: string;
  rejectionReason?: string;
  pdfReportPath?: string;
  lastUpdate: string;
  createdBy?: string;
}

export interface Recipient {
  id: string;
  projectId: number;
  firstName: string;
  lastName: string;
  email: string;
  type: RecipientType;
}

export enum ApprovalType {
  MANUAL_APPROVAL = 'MANUAL_APPROVAL',
  NO_APPROVAL_REQUIRED = 'NO_APPROVAL_REQUIRED',
  AUTO_APPROVAL_AFTER_3_BUSINESS_DAYS = 'AUTO_APPROVAL_AFTER_3_BUSINESS_DAYS',
}

export interface ReportSettings {
  reportFrequency: ReportFrequency;
  isSystemReportUsed: boolean;
  approvalType: ApprovalType;
}
